import React, { useEffect, useState } from "react";
import CustomListingSelector from "../../shared/CustomListingSelector";
import RatingListingSelector from "../../shared/RatingListingSelector";
import { Filter } from "../../../svgs";
import { LuSearch } from "react-icons/lu";
import { cities, statesAndCities } from "../../../data";
import {
	chains,
	hotelType,
	eventType,
	getLast50Years,
	businessFeatures,
	recreationalFeatures,
	roomFeatures,
	ratingFilters,
} from "../../../data/hotelFilters";
import CustomInput from "../../shared/CustomInput";
import { RxCross1 } from "react-icons/rx";
import { IoMdArrowDropdown } from "react-icons/io";

function countValidKeyValuePairs(obj) {
	let count = 0;

	// Iterate through the keys of the object
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			const value = obj[key];

			// Check the conditions based on the value type
			if (Array.isArray(value)) {
				// Check if the array length is at least 1
				if (value.length >= 1) {
					count++;
				}
			} else if (typeof value === "string") {
				// Check if the string has at least 1 character
				if (value.length > 0) {
					count++;
				}
			} else if (typeof value === "number") {
				// Check if the number is greater than zero
				if (value > 0) {
					count++;
				}
			} else if (typeof value === "object" && value !== null) {
				// Check if the object is not null or undefined
				if (Object.keys(value).length > 0) {
					// Checks if the object has any properties
					count++;
				}
			}
		}
	}

	return count;
}

const popupKeyPair = {
	area: true,
	numberOfRooms: true,
	basePrice: true,
	eventType: true,
	hotelType: true,
	hotelChain: true,
	builtYear: true,
	renovatedYear: true,
	businessFeatures: true,
	recreationalFeatures: true,
	roomFeatures: true,
	ratings: true,
};

const VenueStayFilter = ({ filters, setFilters }) => {
	console.log("Filters", filters);

	const [showFilter, setShowFilter] = useState(false);
	const [searchValue, setSearchValue] = useState("");
	const [select, setSelect] = useState("");
	const [selectedRatings, setSelectedRatings] = useState([]);
	const [city, setCity] = useState(filters?.city || "");
	const [selectedEventType, setSelectedEventType] = useState(filters.eventType);
	const [selectedHotelType, setSelectedHotelType] = useState(filters.hotelType);
	const [selectedBuiltYear, setSelectedBuiltYear] = useState("");
	const [selectedRenovatedYear, setSelectedRenovatedYear] = useState("");
	const { years1, years2 } = getLast50Years();
	const [openPopup, setOpenPopup] = useState(popupKeyPair);

	const [numberOfRooms, setNumberOfRooms] = useState(filters.numberOfRooms);
	useEffect(() => {
		console.log("VenueStayFilter: Filters changed:", filters);
		console.log(
			"VenueStayFilter: filters.eventType type:",
			typeof filters.eventType,
			filters.eventType
		);
		console.log(
			"VenueStayFilter: filters.hotelType type:",
			typeof filters.hotelType,
			filters.hotelType
		);
		console.log(
			"VenueStayFilter: filters.city type:",
			typeof filters.city,
			filters.city
		);

		// Only proceed if filters object exists
		if (!filters || Object.keys(filters).length === 0) {
			console.log(
				"VenueStayFilter: No filters provided or empty filters object"
			);
			return;
		}

		setNumberOfRooms(filters.numberOfRooms || "");

		// Handle eventType - could be string, array, or undefined
		if (filters.eventType) {
			if (typeof filters.eventType === "string") {
				console.log(
					"VenueStayFilter: Converting eventType string to array:",
					filters.eventType
				);
				setSelectedEventType([filters.eventType]);
			} else if (Array.isArray(filters.eventType)) {
				console.log(
					"VenueStayFilter: eventType is already array:",
					filters.eventType
				);
				setSelectedEventType(filters.eventType);
			} else {
				console.log(
					"VenueStayFilter: eventType is neither string nor array:",
					filters.eventType
				);
				setSelectedEventType([]);
			}
		} else {
			console.log(
				"VenueStayFilter: No eventType found, setting to empty array"
			);
			setSelectedEventType([]);
		}

		// Handle hotelType - could be string, array, or undefined
		if (filters.hotelType) {
			if (typeof filters.hotelType === "string") {
				console.log(
					"VenueStayFilter: Converting hotelType string to array:",
					filters.hotelType
				);
				setSelectedHotelType([filters.hotelType]);
			} else if (Array.isArray(filters.hotelType)) {
				console.log(
					"VenueStayFilter: hotelType is already array:",
					filters.hotelType
				);
				setSelectedHotelType(filters.hotelType);
			} else {
				console.log(
					"VenueStayFilter: hotelType is neither string nor array:",
					filters.hotelType
				);
				setSelectedHotelType([]);
			}
		} else {
			console.log(
				"VenueStayFilter: No hotelType found, setting to empty array"
			);
			setSelectedHotelType([]);
		}

		setSelectedArea(filters.area || []);
		setSelectedRatings(filters.ratings || []);
		setSelectedBuiltYear(filters.builtYear || []);
		setSelectedRenovatedYear(filters.renovatedYear || []);
		setHotelChain(filters.hotelChain || "");
		setBasePrice(filters.basePrice || "");
		setSelectedRoomFeatures(filters.roomFeatures || []);
		setSelectedBusinessFeatures(filters.businessFeatures || []);
		setSelectedRecreationalFeatures(filters.recreationalFeatures || []);
		setSearchValue(filters.search || "");
		setCity(filters.city || "");
	}, [filters]);
	const [selectedArea, setSelectedArea] = useState([]);
	const [hotelChain, setHotelChain] = useState("");
	const [basePrice, setBasePrice] = useState("");
	const [selectedRoomFeatures, setSelectedRoomFeatures] = useState([]);
	const [selectedBusinessFeatures, setSelectedBusinessFeatures] = useState([]);
	const [selectedRecreationalFeatures, setSelectedRecreationalFeatures] =
		useState([]);
	const handleOpenPopup = (name) => {
		setOpenPopup((prev) => ({
			...prev,
			[name]: !prev[name],
		}));
	};

	const handleSearchChange = (e) => {
		setSearchValue(e.target.value);
		setFilters((prevFilters) => ({
			...prevFilters,
			search: e.target.value,
		}));
	};

	const handleSelectChange = (e) => {
		setSelect(e.target.value);
		setFilters((prevFilters) => ({
			...prevFilters,
			select: e.target.value,
		}));
	};

	useEffect(() => {
		countValidKeyValuePairs(filters);
	}, [filters]);

	const handleCityChange = (e) => {
		const val = e.target.value;
		setCity(val);
		setSelectedArea([]);
		setFilters((prevFilters) => {
			const next = { ...prevFilters, city: val };
			delete next.area;
			return next;
		});
	};

	const handleAreaChange = (selectedOptions) => {
		setSelectedArea(selectedOptions);
		setFilters((prevFilters) => {
			const next = { ...prevFilters };
			if (!selectedOptions.length) delete next.area;
			else next.area = selectedOptions;
			return next;
		});
	};

	const handleSelectedEventType = (selectedOptions) => {
		setSelectedEventType(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			eventType: selectedOptions,
		}));
	};

	const handleSelectedHotelType = (selectedOptions) => {
		setSelectedHotelType(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			hotelType: selectedOptions,
		}));
	};

	const handleSelectedBuiltYear = (selectedOptions) => {
		setSelectedBuiltYear(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			builtYear: selectedOptions,
		}));
	};
	const handleSelectedRenovatedYear = (selectedOptions) => {
		setSelectedRenovatedYear(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			renovatedYear: selectedOptions,
		}));
	};

	const handlehotelChain = (selectedOptions) => {
		setHotelChain(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			hotelChain: selectedOptions,
		}));
	};

	const handleRoomChange = (e) => {
		const value = parseInt(e.target.value, 10);

		if (!isNaN(value) && value >= 0) {
			setNumberOfRooms(value);
			setFilters((prevFilters) => ({
				...prevFilters,
				numberOfRooms: value,
			}));
		} else if (e.target.value === "") {
			setNumberOfRooms("");
			setFilters((prevFilters) => ({
				...prevFilters,
				numberOfRooms: "",
			}));
		}
	};

	const handleBasePriceChange = (e) => {
		const value = parseInt(e.target.value, 10);
		if (!isNaN(value) && Number(value) >= 0) {
			setBasePrice(value);
			setFilters((prevFilters) => ({
				...prevFilters,
				basePrice: value,
			}));
		} else if (e.target.value === "") {
			setBasePrice("");
			setFilters((prevFilters) => ({
				...prevFilters,
				basePrice: "",
			}));
		}
	};

	const handleSelectedRoomFeatures = (selectedOptions) => {
		setSelectedRoomFeatures(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			roomFeatures: selectedOptions,
		}));
	};

	const handleSelectedBusinessFeatures = (selectedOptions) => {
		setSelectedBusinessFeatures(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			businessFeatures: selectedOptions,
		}));
	};

	const handleSelectedRecreationalFeatures = (selectedOptions) => {
		setSelectedRecreationalFeatures(selectedOptions);
		setFilters((prevFilters) => ({
			...prevFilters,
			recreationalFeatures: selectedOptions,
		}));
	};

	const handleRatingChange = (newRating) => {
		setSelectedRatings(newRating);
		setFilters((prevFilters) => ({
			...prevFilters,
			ratings: newRating,
		}));
	};

	const handleShowFilters = () => {
		setShowFilter(true);
		document.body.style.overflow = "hidden";
	};

	const handleCloseFilters = () => {
		setShowFilter(false);
		document.body.style.overflow = "auto";
	};

	const resetAll = () => {
		setCity("");
		setNumberOfRooms("");
		setSelectedEventType([]);
		setSelectedHotelType([]);
		setSelectedBuiltYear([]);
		setSelectedRenovatedYear([]);
		setHotelChain("");
		setBasePrice("");
		setSelectedRatings([]);
		setSelectedRoomFeatures([]);
		setSelectedBusinessFeatures([]);
		setSelectedRecreationalFeatures([]);
		setSelectedArea([]);
		setSearchValue("");
		setFilters({
			search: "",
			city: "",
			area: [],
			numberOfRooms: "",
			eventType: [],
			hotelType: [],
			builtYear: [],
			renovatedYear: [],
			hotelChain: "",
			basePrice: "",
			ratings: [],
			roomFeatures: [],
			businessFeatures: [],
			recreationalFeatures: [],
		});
	};

	return (
		<div className=" w-full   flex flex-col  border-grayNeutral ">
			<div className="md:flex hidden items-center justify-between w-full py-4">
				<p
					className="text-primary underline font-medium cursor-pointer"
					onClick={resetAll}
				>
					Reset All
				</p>
			</div>

			{
				<div className="flex items-end justify-between sm:gap-5 md:mt-0 mt-4 gap-3">
					<div className="flex-1">
						<p className="mb-2">Search</p>
						<div className="border border-grayNeutral flex items-center gap-2 justify-between px-3 py-2 rounded-full">
							<input
								type="text"
								placeholder="Search"
								className="bg-transparent outline-none w-[90%]"
								name=""
								id=""
								value={filters.search || searchValue}
								onChange={handleSearchChange}
							/>
							<LuSearch className="flex-shrink-0" />
						</div>
					</div>
					<div
						onClick={handleShowFilters}
						className="border md:hidden block h-full mb-1 rounded-md p-3"
					>
						<Filter />
					</div>
				</div>
			}

			<div className="mt-4 md:block hidden">
				<p className="text-dark mb-2">Location (Cities)</p>
				{/* <div className="relative cursor-pointer">
          <select
            value={filters.city || city}
            onChange={handleCityChange}
            className="w-full text-grayNeutral py-2 px-3 cursor-pointer appearance-none border outline-none border-bordered rounded-md"
          >
            <option value="" disabled>
              Select City
            </option>
            {cities.map((city) => (
              <option key={city.value} value={city.value}>
                {city.label}
              </option>
            ))}
          </select>
          <IoMdArrowDropdown className="absolute text-dark text-xl right-2 top-1/2 -translate-y-1/2" />
        </div> */}
				<div className="flex flex-wrap items-center gap-2 py-2">
					{cities.map((c) => (
						<div
							key={c.value}
							onClick={() => handleCityChange({ target: { value: c.value } })}
							className={`whitespace-nowrap px-4 py-2 rounded-full border transition-all duration-200 cursor-pointer 
                        ${
													city === c.value
														? "bg-[#FE4747] text-white border-[#FE4747]"
														: "bg-white text-gray-700 border-gray-300 hover:bg-gray-100"
												}`}
						>
							{c.label}
						</div>
					))}
				</div>
			</div>

			<div className="md:block hidden">
				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("area")}>Area</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedArea([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      area: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={
						city
							? statesAndCities[city]
							: [{ name: "No city selected yet!", value: "" }]
					}
					selectedOptions={selectedArea} // Pass selected options
					setSelectedOptions={handleAreaChange}
					handleOpenPopup={() => handleOpenPopup("area")}
					openPopup={openPopup.area}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("numberOfRooms")}>
								No. of Rooms
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setNumberOfRooms("");*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      numberOfRooms: "",*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					content={
						<CustomInput
							placeholder={"Enter your input"}
							type="number"
							value={filters.numberOfRooms ? numberOfRooms : ""}
							onChange={handleRoomChange}
							name="numberOfRooms"
						/>
					}
					handleOpenPopup={() => handleOpenPopup("numberOfRooms")}
					openPopup={openPopup.numberOfRooms}
				/>
				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("basePrice")}>
								Price Per Person
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setBasePrice("");*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      basePrice: "",*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					content={
						<CustomInput
							placeholder={"Enter base price"}
							type="number"
							value={basePrice ? basePrice : ""}
							onChange={handleBasePriceChange}
							name="basePrice"
							error={basePrice === "" ? "Please enter the base price" : ""}
						/>
					}
					handleOpenPopup={() => handleOpenPopup("basePrice")}
					openPopup={openPopup.basePrice}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("eventType")}>
								Event Type
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedEventType([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      eventType: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={eventType}
					selectedOptions={selectedEventType} // Use state variable instead of filters.eventType
					setSelectedOptions={handleSelectedEventType}
					handleOpenPopup={() => handleOpenPopup("eventType")}
					openPopup={openPopup.eventType}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("hotelType")}>
								Hotel Type
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedHotelType([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      hotelType: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={hotelType}
					selectedOptions={selectedHotelType} // Use state variable instead of filters.hotelType
					setSelectedOptions={handleSelectedHotelType}
					handleOpenPopup={() => handleOpenPopup("hotelType")}
					openPopup={openPopup.hotelType}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("hotelChain")}>
								Hotel Chain
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setHotelChain("");*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      hotelChain: "",*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={chains}
					selectedOptions={hotelChain} // Pass selected options
					setSelectedOptions={handlehotelChain}
					handleOpenPopup={() => handleOpenPopup("hotelChain")}
					openPopup={openPopup.hotelChain}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("builtYear")}>
								Built Year
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedBuiltYear([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      builtYear: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={years1}
					selectedOptions={selectedBuiltYear}
					setSelectedOptions={handleSelectedBuiltYear}
					handleOpenPopup={() => handleOpenPopup("builtYear")}
					openPopup={openPopup.builtYear}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("renovatedYear")}>
								Renovated Year
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedRenovatedYear([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      renovatedYear: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={years2}
					selectedOptions={selectedRenovatedYear}
					setSelectedOptions={handleSelectedRenovatedYear}
					handleOpenPopup={() => handleOpenPopup("renovatedYear")}
					openPopup={openPopup.renovatedYear}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("businessFeatures")}>
								Business Features
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedBusinessFeatures([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      businessFeatures: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={businessFeatures}
					selectedOptions={selectedBusinessFeatures} // Pass selected options
					setSelectedOptions={handleSelectedBusinessFeatures}
					handleOpenPopup={() => handleOpenPopup("businessFeatures")}
					openPopup={openPopup.businessFeatures}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("recreationalFeatures")}>
								Recreational Features
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedRecreationalFeatures([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      recreationalFeatures: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={recreationalFeatures}
					selectedOptions={selectedRecreationalFeatures} // Pass selected options
					setSelectedOptions={handleSelectedRecreationalFeatures}
					handleOpenPopup={() => handleOpenPopup("recreationalFeatures")}
					openPopup={openPopup.recreationalFeatures}
				/>

				<CustomListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("roomFeatures")}>
								Room Features
							</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedRoomFeatures([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      roomFeatures: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={roomFeatures}
					selectedOptions={selectedRoomFeatures} // Pass selected options
					setSelectedOptions={handleSelectedRoomFeatures}
					handleOpenPopup={() => handleOpenPopup("roomFeatures")}
					openPopup={openPopup.roomFeatures}
				/>

				<RatingListingSelector
					label={
						<p>
							<span onClick={() => handleOpenPopup("ratings")}>Ratings</span>{" "}
							{/*<span*/}
							{/*  className="underline text-[#FE4747]"*/}
							{/*  onClick={() => {*/}
							{/*    setSelectedRatings([]);*/}
							{/*    setFilters((prevFilters) => ({*/}
							{/*      ...prevFilters,*/}
							{/*      ratings: [],*/}
							{/*    }));*/}
							{/*  }}*/}
							{/*>*/}
							{/*  Reset*/}
							{/*</span>*/}
						</p>
					}
					selectOptions={ratingFilters}
					selectedOptions={selectedRatings} // Pass selected options
					setSelectedOptions={handleRatingChange}
					handleOpenPopup={() => handleOpenPopup("ratings")}
					openPopup={openPopup.ratings}
				/>
			</div>

			{/* filters in mobile view */}
			{showFilter && (
				<div className="fixed inset-0 bg-black bg-opacity-50 z-50">
					<div className="bg-white h-full w-full px-4 pt-6 overflow-y-auto">
						<div className="relative">
							<div className="flex items-center justify-between w-full py-4">
								<div className="" onClick={handleCloseFilters}>
									<RxCross1 className="text-xl" />
								</div>
							</div>

							<div className="flex-1">
								<p className="mb-2">Search</p>
								<div className="border border-grayNeutral flex items-center gap-2 justify-between px-3 py-2 rounded-full">
									<input
										type="text"
										placeholder="Search"
										className="bg-transparent outline-none w-[90%]"
										name=""
										id=""
										value={filters.search || searchValue}
										onChange={handleSearchChange}
									/>
									<LuSearch className="flex-shrink-0" />
								</div>
							</div>

							<div className="mt-4">
								<p className="text-dark mb-2">Location (Cities)</p>
								<div className="relative cursor-pointer">
									<select
										value={filters.city || city}
										onChange={handleCityChange}
										className="w-full text-grayNeutral py-2 px-3 cursor-pointer appearance-none border outline-none border-bordered rounded-md"
									>
										<option value="" disabled>
											Select City
										</option>
										{cities.map((city) => (
											<option key={city.value} value={city.value}>
												{city.label}
											</option>
										))}
									</select>
									<IoMdArrowDropdown className="absolute text-dark text-xl right-2 top-1/2 -translate-y-1/2" />
								</div>
							</div>

							<div className="pb-4">
								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("area")}>Area</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedArea([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      area: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={
										city
											? statesAndCities[city]
											: [{ name: "No city selected yet!", value: "" }]
									}
									selectedOptions={selectedArea} // Pass selected options
									setSelectedOptions={handleAreaChange}
									handleOpenPopup={() => handleOpenPopup("area")}
									openPopup={openPopup.area}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("numberOfRooms")}>
												No. of Rooms
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setNumberOfRooms("");*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      numberOfRooms: "",*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									content={
										<CustomInput
											placeholder={"Enter your input"}
											type="number"
											value={numberOfRooms ? numberOfRooms : ""}
											onChange={handleRoomChange}
											name="numberOfRooms"
										/>
									}
									handleOpenPopup={() => handleOpenPopup("numberOfRooms")}
									openPopup={openPopup.numberOfRooms}
								/>
								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("basePrice")}>
												Price Per Person
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setBasePrice("");*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      basePrice: "",*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									content={
										<CustomInput
											placeholder={"Enter base price"}
											type="number"
											value={basePrice ? basePrice : ""}
											onChange={handleBasePriceChange}
											name="basePrice"
											error={
												basePrice === "" ? "Please enter the base price" : ""
											}
										/>
									}
									handleOpenPopup={() => handleOpenPopup("basePrice")}
									openPopup={openPopup.basePrice}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("eventType")}>
												Event Type
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedEventType([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      eventType: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={eventType}
									selectedOptions={selectedEventType} // Use state variable instead of filters.eventType
									setSelectedOptions={handleSelectedEventType}
									handleOpenPopup={() => handleOpenPopup("eventType")}
									openPopup={openPopup.eventType}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("hotelType")}>
												Hotel Type
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedHotelType([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      hotelType: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={hotelType}
									selectedOptions={selectedHotelType} // Use state variable instead of filters.hotelType
									setSelectedOptions={handleSelectedHotelType}
									handleOpenPopup={() => handleOpenPopup("hotelType")}
									openPopup={openPopup.hotelType}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("hotelChain")}>
												Hotel Chain
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setHotelChain("");*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      hotelChain: "",*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={chains}
									selectedOptions={hotelChain} // Pass selected options
									setSelectedOptions={handlehotelChain}
									handleOpenPopup={() => handleOpenPopup("hotelChain")}
									openPopup={openPopup.hotelChain}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("builtYear")}>
												Built Year
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedBuiltYear([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      builtYear: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={years1}
									selectedOptions={selectedBuiltYear}
									setSelectedOptions={handleSelectedBuiltYear}
									handleOpenPopup={() => handleOpenPopup("builtYear")}
									openPopup={openPopup.builtYear}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("renovatedYear")}>
												Renovated Year
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedRenovatedYear([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      renovatedYear: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={years2}
									selectedOptions={selectedRenovatedYear}
									setSelectedOptions={handleSelectedRenovatedYear}
									handleOpenPopup={() => handleOpenPopup("renovatedYear")}
									openPopup={openPopup.renovatedYear}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("businessFeatures")}>
												Business Features
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedBusinessFeatures([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      businessFeatures: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={businessFeatures}
									selectedOptions={selectedBusinessFeatures} // Pass selected options
									setSelectedOptions={handleSelectedBusinessFeatures}
									handleOpenPopup={() => handleOpenPopup("businessFeatures")}
									openPopup={openPopup.businessFeatures}
								/>

								<CustomListingSelector
									label={
										<p>
											<span
												onClick={() => handleOpenPopup("recreationalFeatures")}
											>
												Recreational Features
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedRecreationalFeatures([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      recreationalFeatures: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={recreationalFeatures}
									selectedOptions={selectedRecreationalFeatures} // Pass selected options
									setSelectedOptions={handleSelectedRecreationalFeatures}
									handleOpenPopup={() =>
										handleOpenPopup("recreationalFeatures")
									}
									openPopup={openPopup.recreationalFeatures}
								/>

								<CustomListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("roomFeatures")}>
												Room Features
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedRoomFeatures([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      roomFeatures: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={roomFeatures}
									selectedOptions={selectedRoomFeatures} // Pass selected options
									setSelectedOptions={handleSelectedRoomFeatures}
									handleOpenPopup={() => handleOpenPopup("roomFeatures")}
									openPopup={openPopup.roomFeatures}
								/>

								<RatingListingSelector
									label={
										<p>
											<span onClick={() => handleOpenPopup("ratings")}>
												Ratings
											</span>{" "}
											{/*<span*/}
											{/*  className="underline text-[#FE4747]"*/}
											{/*  onClick={() => {*/}
											{/*    setSelectedRatings([]);*/}
											{/*    setFilters((prevFilters) => ({*/}
											{/*      ...prevFilters,*/}
											{/*      ratings: [],*/}
											{/*    }));*/}
											{/*  }}*/}
											{/*>*/}
											{/*  Reset*/}
											{/*</span>*/}
										</p>
									}
									selectOptions={ratingFilters}
									selectedOptions={selectedRatings} // Pass selected options
									setSelectedOptions={handleRatingChange}
									handleOpenPopup={() => handleOpenPopup("ratings")}
								/>
							</div>

							<div className="flex sticky bottom-0 shadow-lg items-center gap-4 bg-white py-1.5 text-sm w-full">
								<button
									className="bg-white py-3 flex justify-center items-center underline w-full"
									onClick={() => {
										resetAll();
										handleCloseFilters();
									}}
								>
									Reset all
								</button>
								<button
									className="bg-primary py-3 rounded-md flex justify-center text-white items-center  w-full"
									onClick={() => {
										handleCloseFilters();
									}}
								>
									Save Changes
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default VenueStayFilter;
